import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';
import moment from 'moment';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;
const resumeFilePrefixPattern =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;

function getResumeDisplayFileName(fileName) {
  if (!fileName) return '';
  return fileName.replace(resumeFilePrefixPattern, '');
}

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const columns = [
  {
    headerName: 'Sign Up Date',
    field: 'intSignUpDate',
    width: 105,
    valueFormatter: (params) => {
      if (!params.value) return '';
      const dt = moment(params.value);
      return dt.isValid() ? dt.format('MM/DD/YYYY') : params.value;
    },
  },
  {
    headerName: 'Status',
    field: 'intSignUpStatus',
    width: 120,
  },
  { headerName: 'First Name', field: 'intFirstName', width: 120 },
  { headerName: 'Last Name', field: 'intLastName', width: 120 },
  { headerName: 'Email', field: 'intEmail', width: 220 },
  { headerName: 'Phone', field: 'intPhone', width: 120 },
  { headerName: 'Address', field: 'intAddress', width: 220 },
  { headerName: 'City', field: 'intCity', width: 120 },
  { headerName: 'State', field: 'intState', width: 80 },
  { headerName: 'Zip', field: 'intZip', width: 90 },
  { headerName: 'Languages', field: 'intLanguages', width: 200 },
  {
    headerName: 'Resume File',
    field: 'intResumeFileName',
    width: 220,
    cellRenderer: 'resumeFileRenderer',
  },
];

export class InterpreterSignUpsTableDefault extends Component {
  static displayName = InterpreterSignUpsTableDefault.name;

  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text',
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: columns,
      rowData: this.props.signUps,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        state: this.state,
        handleResumeDownload: this.props.handleResumeDownload,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {
        resumeFileRenderer: ResumeFileRenderer,
      },
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '600px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

class ResumeFileRenderer extends React.Component {
  render() {
    const fullResumeFileName = this.props.value;
    const displayResumeFileName = getResumeDisplayFileName(fullResumeFileName);

    if (!fullResumeFileName) return '';

    return (
      <button
        type="button"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          color: 'blue',
          textDecoration: 'underline',
          cursor: 'pointer',
          font: 'inherit',
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          this.props.context.handleResumeDownload(
            fullResumeFileName,
            displayResumeFileName,
          );
        }}
        title={fullResumeFileName}
      >
        {displayResumeFileName}
      </button>
    );
  }
}
